import {
  getPrograms,
  getAuthorizedClients,
  getUsers,
  updateUsersPoints,
  getClientsByProgrammeId,
  getProgramDetailsById,
} from "@/api/add-points";

const adminAddPoint = {
  namespaced: true,
  state: () => ({
    Programs: [],
    AuthorizedClients: [],
    SelectedUsers: [],
    groupOrLocationOptionsData: null,
  }),
  getters: {
    getGroupOrLocationOptionsData: (state) => {
      return state.groupOrLocationOptionsData;
    },
  },
  actions: {
    fetchAuthorizedClients({ commit }) {
      return new Promise((resolve, reject) => {
        console.log("hello from clients fetch");
        getAuthorizedClients()
          .then((clients) => {
            console.log(clients);
            commit("SET_AUTHORIZED_CLIENTS", clients);
            resolve(clients);
          })
          .catch(() => {
            console.log("error from fetchAuthorizedClients store");
          });
      });
    },
    fetchClientsByProgrammeId({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        console.log("hello from clients fetch");
        getClientsByProgrammeId(params)
          .then((clients) => {
            console.log(clients);
            state.groupOrLocationOptionsData = clients;
            resolve(clients);
          })
          .catch((err) => {
            console.log("error from fetchClientsByProgrammeId store" + err);
          });
      });
    },
    fetchPrograms({ commit }) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients()
          .then((clients) => {
            commit("SET_AUTHORIZED_CLIENTS", clients);
            return getPrograms({
              client_ids: clients.map(({ clientId }) => clientId),
            });
          })
          .then((programs) => {
            commit("SET_PROGRAMS", programs);
          })
          .catch(() => {
            console.log("error from fetchAuthorizedClients store");
          });
      });
    },
    getUsers({ commit }, params) {
      return getUsers(params);
    },
    setSelectedUsers({ commit }, selectedUsers) {
      commit("SET_SELECTED_USERS", selectedUsers);
    },
    updateUsersPoints({ commit }, params) {
      return updateUsersPoints(params);
    },

    getProgramDetailsById({}, params) {
      return new Promise((resolve, reject) => {
        getProgramDetailsById(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err, "err from getProgramDetailsById store");
          });
      });
    },
  },
  mutations: {
    SET_PROGRAMS: (state, programs) => {
      state.Programs = [
        { value: "add", text: "Add Points Without A Program Or Contest" },
        { value: "new", text: "New Program Or Contest" },
        ...(programs.map(({ programId, programName }) => {
          return { value: programId, text: programName };
        }) ?? []),
      ];
    },
    SET_AUTHORIZED_CLIENTS: (state, clients) => {
      state.AuthorizedClients = clients ? clients : [];
    },
    SET_SELECTED_USERS: (state, users) => {
      state.SelectedUsers = users ?? [];
    },
  },
};

export default adminAddPoint;
